import { render, staticRenderFns } from "./BetgameOrderAgreement.vue?vue&type=template&id=843f934a&scoped=true"
import script from "./BetgameOrderAgreement.vue?vue&type=script&lang=js"
export * from "./BetgameOrderAgreement.vue?vue&type=script&lang=js"
import style0 from "./BetgameOrderAgreement.vue?vue&type=style&index=0&id=843f934a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843f934a",
  null
  
)

export default component.exports